module.exports = __webpack_public_path__ + "img/logo-RTX.12439eae.png";